// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1Ym2t","obliqueLineWrap":"membershipbadge_obliqueLineWrap__L9LKU","obliqueLine":"membershipbadge_obliqueLine__pWGwL"};